import { Injectable } from '@angular/core';
import { HttpService } from '@symphony-solo/shared/http/src';
import { Observable } from 'rxjs';
import { AccountPasswordResetRequest, PasswordResetRequest } from '../models';

@Injectable()
export class ResetPasswordService {
  protected path = 'sendpasswordresetemail';
  constructor(private httpService: HttpService) {}

  public resetPassword(passwordResetRequest: PasswordResetRequest): Observable<void> {
    return this.httpService.makePost<void, PasswordResetRequest>('sendaccountpasswordresetemail', passwordResetRequest);
  }
  public resetAccountPassword(accountPasswordResetRequest: AccountPasswordResetRequest): Observable<void> {
    return this.httpService.makePost<void, PasswordResetRequest>('resetaccountpassword', accountPasswordResetRequest);
  }
}
